import { Capacitor } from "@capacitor/core";

// Lot 702 — écran d'accueil natif maintenu jusqu'au PREMIER RENDU du web (plus d'écran blanc entre la disparition du
// splash à 600 ms et l'arrivée de React sur un téléphone lent), avec un filet de sécurité : masqué au plus tard après
// SPLASH_MAX_MS même si le web n'a pas démarré (erreur JS, réseau…). `capacitor.config.json` : launchAutoHide = false.
// Idempotent : App.js (premier rendu), nativePush.initNative (barres système) et le filet peuvent tous l'appeler.
export const SPLASH_MAX_MS = 6000;
let hidden = false;
let fallback = null;

export const hideSplash = async () => {
  if (hidden || !Capacitor.isNativePlatform()) return false;
  hidden = true;
  if (fallback) { clearTimeout(fallback); fallback = null; }
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide({ fadeOutDuration: 250 });
  } catch { /* noop — plugin absent ou déjà masqué */ }
  return true;
};

// À appeler le plus tôt possible (index.js) : garantit que l'écran d'accueil ne reste jamais bloqué.
export const armSplashFallback = (ms = SPLASH_MAX_MS) => {
  if (hidden || fallback || !Capacitor.isNativePlatform()) return;
  fallback = setTimeout(() => { fallback = null; hideSplash(); }, ms);
};

// Masque après la première image peinte (deux rAF : le DOM est posé puis affiché).
export const hideSplashAfterFirstPaint = () => {
  if (hidden || !Capacitor.isNativePlatform()) return;
  const raf = typeof requestAnimationFrame === "function" ? requestAnimationFrame : (cb) => setTimeout(cb, 16);
  raf(() => raf(() => { hideSplash(); }));
};

// Tests uniquement.
export const __resetSplash = () => { hidden = false; if (fallback) clearTimeout(fallback); fallback = null; };
